import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=TITLE_DETAIL_REDESIGN:control
// ?preferred_variant=TITLE_DETAIL_REDESIGN:variant_1
// ?preferred_variant=TITLE_DETAIL_REDESIGN:variant_2
// ?preferred_variant=TITLE_DETAIL_REDESIGN:variant_3

export const TitleDetailRedesignName = 'TITLE_DETAIL_REDESIGN' as const;

export type TitleDetailRedesignVariants = ToVariants<typeof TitleDetailRedesignVariants>;

export const TitleDetailRedesignVariants = {
	/** Current Title Detail */
	CONTROL: 'control',
	/** Backdrop */
	VARIANT_1: 'variant_1',
	/** No backdrop sidebar right */
	VARIANT_2: 'variant_2',
	/** No backdrop sidebar left */
	VARIANT_3: 'variant_3',
} as const;

export default generate(TitleDetailRedesignName, TitleDetailRedesignVariants);
